/* eslint-disable no-redeclare */
import { z } from 'zod';

export const ProductType = z.enum(['HEALTH', 'MEDICARE', 'MEDICARE_ADVANTAGE']);
export type ProductType = z.infer<typeof ProductType>;

export const SubProductType = z.enum([
  'MEDICARE_ADVANTAGE',
  'MEDICARE_SUPPLEMENT',
]);
export type SubProductType = z.infer<typeof SubProductType>;
